<template>
  <v-card outlined>
    <v-card-title>
      <v-btn icon text :color="selected? 'primary': 'accent'" @click="onViewClick">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <p class="ml-2 text-h6">{{titulo}}</p>
    </v-card-title>
    <v-card-text>
      <div><strong>Assunto:</strong> {{ assunto }}</div>
      <div><strong>Classe:</strong> {{ classe }}</div>
      <div><strong>Competência:</strong> {{ competencia }}</div>
      <div><strong>Magistrado:</strong> {{ magistrado }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue"

export default Vue.component("tj-item-card", {
  props: {
    item:Object,
    selected: Boolean
  },

  computed: {
    titulo(){
      return this.item? this.item.titulo: ""
    },
    assunto(){
      return this.item? this.item.assunto: ""
    },
    classe(){
      return this.item? this.item.classe: ""
    },
    competencia(){
      return this.item? this.item.competencia: ""
    },
    magistrado(){
      return this.item? this.item.magistrado: ""
    },


    

  }, 

  methods: {
    onViewClick(){
      this.$emit("view", this.item)
    }
  }

})
</script>